import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const loadLogo = () => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const w = 480;
    const h = Math.round((img.height / img.width) * w);
    const c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    c.getContext('2d').drawImage(img, 0, 0, w, h);
    resolve({ data: c.toDataURL('image/png'), ratio: h / w });
  };
  img.onerror = () => resolve(null);
  img.src = '/datapro-logo.png';
});

const safeName = (s) => String(s || 'resultados')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/[^A-Za-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 60);

// Builds the provisional-results PDF and returns a File ready to download/share.
export const buildProvisionalPdf = async ({ race, rows, isBestLap }) => {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const pageW = doc.internal.pageSize.getWidth();
  const logo = await loadLogo();
  let y = 14;
  if (logo) {
    const w = 38;
    doc.addImage(logo.data, 'PNG', 14, y - 4, w, w * logo.ratio);
  }
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.setTextColor(20);
  doc.text('Clasificación provisoria', pageW - 14, y + 2, { align: 'right' });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(110);
  doc.text(isBestLap ? 'Orden por mejor vuelta' : 'Orden por posición de carrera', pageW - 14, y + 8, { align: 'right' });
  y += 26;

  const event = race?.speedhive_event_name || race?.name || '';
  const session = [race?.speedhive_group_name, race?.speedhive_session_name].filter(Boolean).join(' · ');
  const date = race?.date ? new Date(race.date).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';
  doc.setTextColor(20);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text(doc.splitTextToSize(event, pageW - 28), 14, y);
  y += 6;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(80);
  const sub = [session, date, race?.circuit].filter(Boolean).join('  ·  ');
  if (sub) { doc.text(doc.splitTextToSize(sub, pageW - 28), 14, y); y += 6; }

  autoTable(doc, {
    startY: y + 2,
    head: [['Pos', '#', 'Piloto', 'Vtas', 'Mejor vuelta', 'Diferencia', 'Estado']],
    body: rows.map((r) => [`P${r.pos}`, `#${r.number}`, r.name, r.laps, r.best, r.gap, r.state]),
    styles: { fontSize: 9, cellPadding: 2.2 },
    headStyles: { fillColor: [185, 28, 28], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    columnStyles: {
      0: { fontStyle: 'bold', cellWidth: 14 },
      1: { cellWidth: 14 },
      3: { halign: 'right', cellWidth: 14 },
      4: { halign: 'right', font: 'courier' },
      5: { halign: 'right', font: 'courier', textColor: [185, 28, 28] },
      6: { halign: 'center' },
    },
    didParseCell: (d) => {
      if (d.section === 'body' && d.row.index === 0) d.cell.styles.fillColor = [254, 243, 199];
    },
  });

  const endY = doc.lastAutoTable.finalY + 8;
  doc.setFontSize(8);
  doc.setTextColor(120);
  doc.text(
    doc.splitTextToSize('Resultado provisorio calculado automáticamente con los datos capturados. Puede diferir del acta oficial hasta que el organizador la publique.', pageW - 28),
    14, endY,
  );
  const pages = doc.getNumberOfPages();
  for (let i = 1; i <= pages; i += 1) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150);
    doc.text(`DATAPRO Racing Analytics · ${new Date().toLocaleString('es-AR')}`, 14, 290);
    doc.text(`${i}/${pages}`, pageW - 14, 290, { align: 'right' });
  }
  const filename = `Resultados_${safeName(session || event)}.pdf`;
  return new File([doc.output('blob')], filename, { type: 'application/pdf' });
};

export const downloadFile = (file) => {
  const url = URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};
